import { MediaType } from '../../../../../../Chat.enum';
import { tDriveFile } from '../../../../../../Chat.types';
import { fileExtensionMap } from '../../../Thumbnail/Thumbnail.constants';
import { fileIconMap } from './DriveFilesAction.constants';

// The type the storage service gives a file it cannot type (BUG-862's
// DefaultMimeType). getFileMetaData falls back to application/pdf instead,
// which would label an unmapped file a PDF.
const UNMAPPED_MIME_TYPE = 'application/octet-stream';

/**
 * Gives a shared-folder record that came back with no type the type of its
 * name's extension, from the extension map the picker sends these files with.
 * An extension the map does not know becomes a generic document. The storage
 * service from before BUG-862 #157 writes such records when a file is shared
 * with a PATCH (BUG-1067). Untyped, a photo shows as a document and the BFF
 * labels it DOCUMENT. A record that has a type is returned unchanged.
 */
export function withTypeFromName(file: tDriveFile): tDriveFile {
  if (file.mimeType || !file.name) {
    return file;
  }

  const dot = file.name.lastIndexOf('.');
  const mapped =
    dot === -1
      ? undefined
      : fileExtensionMap[file.name.slice(dot).toLowerCase()];

  if (!mapped) {
    return {
      ...file,
      mimeType: UNMAPPED_MIME_TYPE,
      mediaType: MediaType.DOCUMENT,
    };
  }

  return { ...file, mimeType: mapped.mimeType, mediaType: mapped.mediaType };
}

/**
 * Whether a shared-folder file is a .mov the picker must not send (still
 * blocked, see UploadFileAction's commented-out video/quicktime). Judged by
 * type or by the name's extension, the same rule as the drop zones: Android
 * can store a .mov as video/mp4 (BUG-1066). A name that merely contains "mov"
 * (barrasmoviles.mp4) is not a .mov (BUG-1149).
 */
export function isBlockedMovFile(file: Pick<tDriveFile, 'mimeType' | 'name'>) {
  return (
    Boolean(file.mimeType?.startsWith('video/quicktime')) ||
    Boolean(file.name?.toLowerCase().endsWith('.mov'))
  );
}

export function showFileIcon(file: tDriveFile) {
  const fileExtension = file.mimeType.split('/')[1];

  return fileIconMap[fileExtension] || '/images/storage/docIcon.png';
}

export function isImage(file: tDriveFile) {
  const fileExtension = file.mimeType.split('/')[1];
  const imageExtensions = ['png', 'jpg', 'jpeg'];

  return imageExtensions.includes(fileExtension);
}
